export const licensesList = [
  {
    name: '@humanwhocodes/object-schema',
    version: '1.2.1',
    license: 'New BSD',
    author: 'Human Who Codes',
  },
  {
    name: '@protobufjs/aspromise',
    version: '1.1.2',
    license: 'New BSD',
    author: 'Daniel Wirtz',
  },
  {
    name: '@protobufjs/base64',
    version: '1.1.2',
    license: 'New BSD',
    author: 'Daniel Wirtz',
  },
  {
    name: '@protobufjs/codegen',
    version: '2.0.4',
    license: 'New BSD',
    author: 'Daniel Wirtz',
  },
  {
    name: '@protobufjs/eventemitter',
    version: '1.1.0',
    license: 'New BSD',
    author: 'Daniel Wirtz',
  },
  {
    name: '@protobufjs/fetch',
    version: '1.1.0',
    license: 'New BSD',
    author: 'Daniel Wirtz',
  },
  {
    name: '@protobufjs/float',
    version: '1.0.2',
    license: 'New BSD',
    author: 'Daniel Wirtz',
  },
  {
    name: '@protobufjs/inquire',
    version: '1.1.0',
    license: 'New BSD',
    author: 'Daniel Wirtz',
  },
  {
    name: '@protobufjs/path',
    version: '1.1.2',
    license: 'New BSD',
    author: 'Daniel Wirtz',
  },
  {
    name: '@protobufjs/pool',
    version: '1.1.0',
    license: 'New BSD',
    author: 'Daniel Wirtz',
  },
  {
    name: '@protobufjs/utf8',
    version: '1.1.0',
    license: 'New BSD',
    author: 'Daniel Wirtz',
  },
  {
    name: '@sinonjs/commons',
    version: '1.8.3',
    license: 'New BSD',
    author: 'Sinon.JS',
  },
  {
    name: '@sinonjs/fake-timers',
    version: '8.1.0',
    license: 'New BSD',
    author: 'Christian Johansen',
  },
  {
    name: '@xtuc/ieee754',
    version: '1.2.0',
    license: 'New BSD',
    author: 'Fair Oaks Labs, Inc.',
  },
  {
    name: 'abab',
    version: '2.0.6',
    license: 'New BSD',
    author: 'W3C and Jeff Carpenter <jeffcarp@chromium.org>',
  },
  {
    name: 'argparse',
    version: '2.0.1',
    license: 'Python-2.0',
    author: '',
  },
  {
    name: 'axe-core',
    version: '4.4.2',
    license: 'Mozilla Public License 2.0',
    author: 'Deque Systems, Inc.',
  },
  {
    name: 'babel-plugin-istanbul',
    version: '6.1.1',
    license: 'New BSD',
    author: 'Istanbul Code Coverage',
  },
  {
    name: 'big-integer',
    version: '1.6.51',
    license: 'Unlicense',
    author: 'Peter Olson <peter.e.c.olson+npm@gmail.com>',
  },
  {
    name: 'caniuse-lite',
    version: '1.0.30001361',
    license: 'CC-BY-4.0',
    author: 'Ben Briggs <beneb.info@gmail.com>',
  },
  {
    name: 'diff',
    version: '5.1.0',
    license: 'New BSD',
    author: '',
  },
  {
    name: 'eslint-plugin-flowtype',
    version: '8.0.3',
    license: 'New BSD',
    author: 'Kevin Decker <kpdecker@gmail.com>',
  },
  {
    name: 'esquery',
    version: '1.4.0',
    license: 'New BSD',
    author: 'Joel Feenstra',
  },
  {
    name: 'filesize',
    version: '8.0.7',
    license: 'New BSD',
    author: 'Jason Mulligan',
  },
  {
    name: 'fs-monkey',
    version: '1.0.3',
    license: 'Unlicense',
    author: '',
  },
  {
    name: 'hoist-non-react-statics',
    version: '3.3.2',
    license: 'New BSD',
    author: 'Yahoo! Inc.',
  },
  {
    name: 'istanbul-lib-coverage',
    version: '3.2.0',
    license: 'New BSD',
    author: 'Yahoo! Inc.',
  },
  {
    name: 'istanbul-lib-instrument',
    version: '5.2.0',
    license: 'New BSD',
    author: 'Isaac Z. Schlueter and Contributors',
  },
  {
    name: 'istanbul-lib-report',
    version: '3.0.0',
    license: 'New BSD',
    author: 'Yahoo! Inc.',
  },
  {
    name: 'istanbul-lib-source-maps',
    version: '4.0.1',
    license: 'New BSD',
    author: 'Yahoo! Inc.',
  },
  {
    name: 'istanbul-reports',
    version: '3.1.4',
    license: 'New BSD',
    author: 'Yahoo! Inc.',
  },
  {
    name: 'json-schema',
    version: '0.4.0',
    license: '(AFL-2.1 OR BSD-3-Clause)',
    author: 'The Dojo Foundation',
  },
  {
    name: 'language-subtag-registry',
    version: '0.3.21',
    license: 'ODC-By-1.0',
    author: '',
  },
  {
    name: 'lz-string',
    version: '1.4.4',
    license: 'WTFPL',
    author: 'Sam Hocevar <sam@hocevar.net>',
  },
  {
    name: 'makeerror',
    version: '1.0.21',
    license: 'New BSD',
    author: 'Naitik Shah',
  },
  {
    name: 'memfs',
    version: '3.4.7',
    license: 'Unlicense',
    author: '',
  },
  {
    name: 'node-forge',
    version: '1.3.1',
    license: '(BSD-3-Clause OR GPL-2.0)',
    author: 'Stefan Siegl, Dave Longley',
  },
  {
    name: 'npm',
    version: '8.12.2',
    license: 'Artistic-2.0',
    author: 'Isaac Z. Schlueter <i@izs.me>',
  },
  {
    name: 'pako',
    version: '1.0.11',
    license: '(MIT AND Zlib)',
    author: 'Vitaly Puzrin and Andrei Tuputcyn',
  },
  {
    name: 'protobufjs',
    version: '6.11.3',
    license: 'New BSD',
    author: 'Daniel Wirtz <dcode+protobufjs@dcode.io>',
  },
  {
    name: 'protobufjs',
    version: '7.1.1',
    license: 'New BSD',
    author: 'Daniel Wirtz <dcode+protobufjs@dcode.io>',
  },
  {
    name: 'qrcode-terminal',
    version: '0.12.0',
    license: 'Apache*',
    author: '',
  },
  {
    name: 'qs',
    version: '6.10.3',
    license: 'New BSD',
    author:
      'Nathan LaFreniere and other contributors(https://github.com/ljharb/qs/graphs/contributors)',
  },
  {
    name: 'react-transition-group',
    version: '4.4.2',
    license: 'New BSD',
    author: 'Facebook, Inc.',
  },
  {
    name: 'serialize-javascript',
    version: '4.0.0',
    license: 'New BSD',
    author: 'Yahoo! Inc.',
  },
  {
    name: 'serialize-javascript',
    version: '6.0.0',
    license: 'New BSD',
    author: 'Yahoo! Inc.',
  },
  {
    name: 'source-map',
    version: '0.6.1',
    license: 'New BSD',
    author: 'Mozilla Foundation',
  },
  {
    name: 'source-map',
    version: '0.7.4',
    license: 'New BSD',
    author: 'Mozilla Foundation',
  },
  {
    name: 'source-map',
    version: '0.8.0-beta.0',
    license: 'New BSD',
    author: 'Mozilla Foundation',
  },
  {
    name: 'source-map-js',
    version: '0.6.2',
    license: 'New BSD',
    author: 'Mozilla Foundation',
  },
  {
    name: 'source-map-js',
    version: '1.0.2',
    license: 'New BSD',
    author: 'Mozilla Foundation',
  },
  {
    name: 'spdx-exceptions',
    version: '2.3.0',
    license: 'CC-BY-3.0',
    author: 'The Linux Foundation',
  },
  {
    name: 'sprintf-js',
    version: '1.0.3',
    license: 'New BSD',
    author: 'Alexandru Marasteanu <hello@alexei.ro>',
  },
  {
    name: 'table',
    version: '6.8.0',
    license: 'New BSD',
    author: 'Gajus Kuizinas',
  },
  {
    name: 'tmpl',
    version: '1.0.5',
    license: 'New BSD',
    author: 'Naitik Shah',
  },
  {
    name: 'tough-cookie',
    version: '4.0.0',
    license: 'New BSD',
    author: 'Salesforce.com, Inc.',
  },
  {
    name: 'tslib',
    version: '1.14.1',
    license: 'BSD Zero Clause License',
    author: 'Microsoft Corporation',
  },
  {
    name: 'tslib',
    version: '2.4.0',
    license: 'BSD Zero Clause License',
    author: 'Microsoft Corporation',
  },
];
